import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { employees, employeesIsMobile } from "my-hr/configs/my-hr-table-defs";
import { useMyHrEmployees } from "my-hr/hooks";
import { OcCard, OcDataTable } from "oc/components";

type MyHrEmployeeListProps = {
  tableId: string;
  tableData: any;
  setTableData: (data: any) => void;
  onSelectRow: (row: any) => void;
  isMobile: boolean;
};

export const MyHrEmployeeList: React.FC<MyHrEmployeeListProps> = ({
  tableId,
  tableData,
  setTableData,
  onSelectRow,
  isMobile,
}) => {
  const { t } = useTranslation();
  const [selectedRowId, setSelectedRowId] = useState<
    string | number | undefined
  >(undefined);

  const { data, loading } = useMyHrEmployees({
    sortField: tableData?.sortField,
    sortDirection: tableData?.sortDirection,
    searchField: tableData?.searchField,
    searchText: tableData?.searchText,
    page: tableData?.page,
    pageSize: tableData?.pageSize,
  });

  const tableDef = isMobile ? employeesIsMobile : employees;

  const filteredTableDef = {
    id: employees?.id,
    columns: employees?.columns?.filter(
      (column) =>
        !employeesIsMobile?.columns?.some(
          (mobileColumn) => mobileColumn?.id === column?.id,
        ),
    ),
  };

  const onSelectRowHandler = (row: any) => {
    if (isMobile) {
      setSelectedRowId(selectedRowId === row?._id ? undefined : row?._id);
      setTableData({
        ...tableData,
        selectedRowValue: row?.code,
      });
    } else {
      onSelectRow(row);
    }
  };

  return (
    <OcCard label={t("MY_HR_SELECT_EMPLOYEE")}>
      <OcDataTable
        data={data}
        loading={loading && data?.rows?.length === 0}
        tableDef={tableDef}
        tableData={tableData}
        setTableData={setTableData}
        onSelectRow={onSelectRowHandler}
        tableId={tableId}
        pagination={true}
        filteredTableDef={filteredTableDef}
        selectedRowId={selectedRowId}
      />
    </OcCard>
  );
};

export default MyHrEmployeeList;
